import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-bespoke-corners-form',
    templateUrl: './bespoke-corners-form.component.html',
    styleUrls: ['./bespoke-corners-form.component.scss']
})
export class BespokeCornersFormComponent implements OnInit {

    @Input() product;
    @Output() recalculate = new EventEmitter();
    @Output() setSubStep = new EventEmitter();
    @Output() clearSubStep = new EventEmitter();

    constructor() { }

    ngOnInit(): void {
    }

    calcBespokeCost() {
        this.recalculate.emit();
    }

    triggerSetSubStep(step) {
        this.setSubStep.emit(step);
    }

    triggerClearSubStep() {
        this.clearSubStep.emit();
    }


}
